import React, { Component } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import './ColorPopOver.scss';
import ImgTag from '../ImgTag';
import addButtonWhite from '../../../../assets/icons/ic_add_blue.png';
import Button from '../Button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { updateBotValue, successGenericDataGet } from '../../../Redux/Actions/uiActions';
class ColorPopOver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isGeneric: false,
            popoverObj: false,
            isOpen: false,
            selectedColor: this.props.selectedColor ? this.props.selectedColor : '#ffffff',
            groupDesc: 'Please attach an image which is minimum 72 x 72 px with 72 DPI.'
        }
    }

    componentDidMount() {
        const firstParam = this.props.location.pathname.split('/')[1];
        if (firstParam === 'genericconfig' && !this.state.isGeneric) {
            this.setState({ isGeneric: true })
        } else if (this.state.isGeneric) {
            this.setState({ isGeneric: false })
        }
    }

    addButton = (imageSrc) => {
        return (
            <span className='eb-icon-btn-image'>
                <ImgTag
                    className='image'
                    src={imageSrc}
                    alt='Add'
                />
            </span>
        );
    }

    validateColor = (e) => {
        let currentVal = e.target.value;

        if (currentVal.length === 3 || currentVal.length === 4) {
            this.setState({
                selectedColor: '#' + currentVal
            })
        } else if (currentVal.length === 6 || currentVal.length === 8) {
            this.setState({
                selectedColor: '#' + currentVal
            })
        } else {

        }

        return;
    }

    render() {
        let ts = new Date().getTime();
        let tempId = parseInt(Math.random(10000) * 10000) + ts;
        return (
            <>
                <Popover
                    isOpen={this.state.popoverObj}
                    positions={['bottom', 'left', 'right']}
                    reposition={true}
                    padding={5}
                    margin={-15}
                    onClickOutside={() => {
                        this.setState({ popoverObj: false })
                    }}
                    parentElement={document.getElementById('mainBodySection')}
                    containerClassName='popover-menu-outer-wrapper color-popover-wrapper'
                    content={({ position, childRect, popoverRect }) => (
                        <div className='popover-wrapper popover-menu-wrapper popover-align-left'
                        > <ArrowContainer
                            position={position}
                            childRect={childRect}
                            popoverRect={popoverRect}
                            arrowColor={"#fff"}
                            arrowSize={12}
                            arrowStyle={{ opacity: 1 }}
                        >
                                <div className='popover-block popover-color-block'>
                                    <p className='color-popover-description'>
                                        Enter your color
                                    </p>
                                    <div className='config-value-info'>
                                        <div className='color-container-popover'>
                                            <input className='color-text-input' type='color' autoComplete='off' data-prefilled='true' pattern='\d*' defaultValue={this.state.selectedColor} id={tempId + 1} onChange={(e) => { this.setState({ selectedColor: e.target.value, selectedColorfrom: e.target.value }) }} />
                                            <label className='color-text-input-label' htmlFor={tempId + 1} style={{
                                                'backgroundColor': this.state.selectedColor
                                            }}>
                                            </label>
                                            <span className='color-text-container'>
                                                <span className='color-text-hash'>#</span>
                                                <input className='color-text-hash-input' type='text' maxLength='8' key={this.state.selectedColorfrom} defaultValue={this.state.selectedColor.slice(1, 7)} onChange={(e) => { this.validateColor(e) }} />
                                                <span className='color-text-unit'>Hex</span>
                                            </span>
                                            <span className='color-desc-container'>
                                                Applies to: Headers, chat bot avatar, suggestions, send icon, buttons
                                            </span>
                                        </div>
                                    </div>
                                    <div className='go-float-right btn-wrapper'>
                                        <Button
                                            className='btn btn-default eb-btn-style eb-button-reclear'
                                            type='button'
                                            title='Clear'
                                            value={'Clear'}
                                            buttonOnClick={(e) => {
                                                this.props.onUplaod(e, '');
                                                this.setState({ selectedColor: '', popoverObj: !this.state.popoverObj });
                                                // this.setState({ selectedColor: '#ffffff' });
                                            }}
                                        />
                                        <Button
                                            className='btn btn-default eb-btn-style'
                                            type='button'
                                            title='Close'
                                            value={'Close'}
                                            buttonOnClick={(e) => {
                                                this.setState({ popoverObj: !this.state.popoverObj });
                                                // this.setState({ selectedColor: '#ffffff' });
                                            }}
                                        />
                                        <Button
                                            className='btn btn-default eb-btn-style eb-gradient-btn-linear'
                                            type='button'
                                            title='Apply'
                                            value={'Apply'}
                                            buttonOnClick={(e) => {
                                                if (this.state.selectedColor.length === 4 || this.state.selectedColor.length === 5 || this.state.selectedColor.length === 7 || this.state.selectedColor.length === 8) {
                                                    this.props.onUplaod(e, this.state.selectedColor);
                                                    this.setState({ popoverObj: !this.state.popoverObj });
                                                } else {
                                                    alert('No color selected');
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </ArrowContainer>
                        </div>
                    )}
                >
                    <button className='eb-icon-btn-style' type='button' title='Select Color' onClick={() => { this.setState({ popoverObj: !this.state.popoverObj }); }}>
                        <span className='eb-icon-btn-image'>
                            <ImgTag
                                className='image'
                                src={addButtonWhite}
                                alt='More'
                            />
                        </span>
                    </button>
                </Popover>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : {},
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {}
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateBotValue,
        successGenericDataGet
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ColorPopOver));